import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

const ServiceList = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7 mt-20">
      <div className="border border-gray-200 text-center">
        <div className="bg-gray-100 h-32 vhcenter">
          <Image
            width="100"
            height="100"
            src="/assets/images/wheelchair.svg"
            alt="resturant"
            className="m-auto"
          />
        </div>
        <div className="p-10">
          <div className="text-xl font-medium">
            WHEELCHAIR ACCESSIBLE VEHICLES
          </div>
          <div className="mt-3 text-gray-600">
            Get wheelchair-access vehicles for all your travel needs. Shipley
            Central is here to provide reliable transportation to and from the
            airport, bus stations, or even the coast. Whether you're planning a
            local trip or exploring the entire UK, book online now to secure
            your wheelchair-access vehicle.
          </div>
        </div>
      </div>
      <div className="border border-gray-200 text-center">
        <div className="bg-gray-100 h-32 vhcenter">
          <Image
            width="100"
            height="100"
            src="/assets/images/airporttransfer.svg"
            alt="airport"
            className="m-auto"
          />
        </div>
        <div className="p-10">
          <div className="text-xl font-medium">AIRPORT TRANSFERS</div>
          <div className="mt-3 text-gray-600">
            Get peace of mind knowing that we have all the inside scoop on which
            airlines fly from which terminal. Our reliable team will not only
            pick you up and drop you off at the airport for a fixed price, but
            we will also keep track of your flight's arrival time. If your
            flight is running late, we'll make sure to adjust your booking
            without any additional fees.
          </div>
        </div>
      </div>

      <div className="border border-gray-200 text-center">
        <div className="bg-gray-100 h-32 vhcenter">
          <Image
            width="100"
            height="100"
            src="/assets/images/courier.svg"
            alt="hospitals"
            className="m-auto"
          />
        </div>
        <div className="p-10">
          <div className="text-xl font-medium">
            COURIER & SMALL PARCEL SERVICE
          </div>
          <div className="mt-3 text-gray-600">
            Get your letters, packages, and small parcels delivered hassle-free
            in the area. Our reliable and efficient service is perfect for
            corporate clients and local hospitals. Need it urgently? We also
            offer a Same Day priority service.{' '}
            <Link href="/">
              <a className="text-primary font-bold">Book</a>
            </Link>{' '}
            your courier service now. Call us or click below to book online.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceList;
